module.exports = __webpack_public_path__ + "static/media/logo-red.e13c401e.svg";